// extracted by mini-css-extract-plugin
export default {"inputs":"FeesDetails_inputs__CuvlK","inputs__section":"FeesDetails_inputs__section__BuIwm","inputSubtitle":"FeesDetails_inputSubtitle__LpD-Z"};